/**
 * Plan-level feature flag key for the accounting module (ledger screens and the
 * financial reports built on it). Off unless a plan or a per-org plan override
 * sets `features.accounting` to true — the module is knowingly incomplete, so it
 * is shown only to businesses we switch on deliberately.
 */
export const ACCOUNTING_FEATURE = "accounting";
